/**
 * @generated SignedSource<<547de3b68323bb8dae94d034cb49549f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"flag_issueViewRedaction_RedactionFlag" | "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue">;
  readonly " $fragmentType": "ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment";
};
export type ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment$key = {
  readonly " $data"?: ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueViewRedaction_OnboardingAndFlag_issueViewRelayFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue"
    },
    {
      "kind": "FragmentSpread",
      "name": "flag_issueViewRedaction_RedactionFlag"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "40d55c8347d5247734b0125723e9e175";

export default node;
